/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUserAssetsDetail.vue?vue&type=template&id=7bc98674&scoped=true"
import script from "./popUserAssetsDetail.vue?vue&type=script&lang=js"
export * from "./popUserAssetsDetail.vue?vue&type=script&lang=js"
import style0 from "./popUserAssetsDetail.vue?vue&type=style&index=0&id=7bc98674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc98674",
  null
  
)

export default component.exports